import React from 'react';
import {Dialog} from 'material-ui';
import {DialogTitle} from 'material-ui';
import {DialogContent} from 'material-ui';
import './GoToNextRoundDialog.css';
import MyButton from '../components/MyButton';
import {colors} from '../styles/colors';

function SubmitAgainDialog({
	isOpen,
	onClose,
	title,
	ctaText,
	onCtaPress,
	ctaLoading,
}) {
	return (
		<Dialog
			className='go-to-next-round-dialog'
			open={!!isOpen}
			onClose={onClose}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
			style={{borderRadius: 50}}
			actionsContainerClassName={{borderRadius: 50}}
			bodyStyle={{borderRadius: 50}}
			style={{borderRadius: 50}}
		>
			<DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
			<DialogContent>
				<MyButton
					loading={ctaLoading}
					size='large'
					style={{
						background: colors.primaryColor,
						color: '#fff',
						textAlign: 'center',
					}}
					onPressButton={onCtaPress}
					title={ctaText}
				/>
			</DialogContent>
		</Dialog>
	);
}
export default SubmitAgainDialog;



// WEBPACK FOOTER //
// ./src/workout/SubmitAgainDialog.js